import { render, staticRenderFns } from "./AsideRight.vue?vue&type=template&id=0cbe3000"
import script from "./AsideRight.vue?vue&type=script&lang=js"
export * from "./AsideRight.vue?vue&type=script&lang=js"
import style0 from "./AsideRight.vue?vue&type=style&index=0&id=0cbe3000&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports